import { singleUi } from "../../../utilities/single-ui";

export function initSingle(container) {
console.log('initSingle', container);

// ui for single page; copy links; open and close of side links;
singleUi(container);
}
